import "sweetalert";
import "#/shared/api/api-host-global.js";

(function ($) {
  window.ClientExceptionNotifier = {
    defaults: {
      title: "An error has occurred",
      text: "We'll fix this right away!",
      placeholder: "What you were doing when the error occurred?",
      reportUrl:
        (window.Sparkle?.apiHost ? window.Sparkle.apiHost + window.SparkleConfig.routes.errorReport : null) ||
        window.location.origin + window.SparkleConfig.routes.errorReport,
      canDescribe: true,
      notifyUser: true,
      throwException: true,
      recoveryFunction: function (exception) {}, // Do something to recover from the error. Default is no-op
    },
    notify: function (exception, config) {
      config = jQuery.extend({}, this.defaults, config);
      var inputId = "client_exception_notifier_report";

      if (config.canDescribe) {
        config.text = config.text + '<br><br><textarea id="' + inputId + '" placeholder="' + config.placeholder + '"/>';
      }

      if (!config.reportUrl) {
        console.error("Must set a reportUrl before notifying");
        return;
      }

      if (config.notifyUser) {
        var callback = function (isConfirm) {
          // Specify an argument to cause this callback to trigger regardless of confirm/cancel
          var reportData = generateAdditionalReportData(
            { message: String(exception), description: jQuery("#" + inputId).val() },
            config.reportData,
          );
          sendReport(reportData, config.reportUrl).then(function () {
            config.recoveryFunction(exception);
          });
        };

        window.sweetAlert(
          {
            type: "error",
            title: config.title,
            text: config.text,
            html: true,
            confirmButtonText: "Close",
            closeOnConfirm: true,
          },
          callback,
        );
      } else {
        var reportData = generateAdditionalReportData(
          { message: String(exception), description: config.description },
          config.reportData,
        );
        sendReport(reportData, config.reportUrl).then(function () {
          config.recoveryFunction(exception);
        });
      }

      if (config.throwException) {
        throw exception;
      }
    },
    report: function (reportData, reportUrl) {
      sendReport(reportData, reportUrl || this.defaults.reportUrl);
    },
  };

  // HELPER FUNCTIONS

  // Sent as a JSON body, which Rails decodes without Rack's form parser, so a large report is not subject to that
  // parser's limit of 4,096 parameters.
  function sendReport(reportData, reportUrl) {
    return jQuery.ajax({
      url: reportUrl,
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify({ report: reportData }),
    });
  }

  function generateAdditionalReportData(data, additionalData) {
    if (typeof additionalData == "function") {
      additionalData = additionalData();
    }
    return jQuery.extend({ url: window.location.href }, data, additionalData);
  }
})(jQuery);
